import { jsx as _jsx } from "react/jsx-runtime";
import { Collapsible, getTestId, isValidObject, StateConfigContext } from '@airtel/air-design-system';
import { merge } from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { View } from 'react-native';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { StatusCardWidget } from '../../../status-card-widget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { photoVerificationConfig, successAvatarConfig, videoVerificationConfig } from './PhotoVideoVerificationConfig';
import { getIsDisabledState } from './PhotoVideoVerificationUtils';
export var PhotoVideoVerification = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => (props === null || props === void 0 ? void 0 : props.variant) === 'PHOTO_VERIFICATION' ? merge({}, photoVerificationConfig, props) : merge({}, videoVerificationConfig, props), [photoVerificationConfig, videoVerificationConfig, props]),
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    onUserAction = _useMemo.onUserAction,
    openCameraButtonPressMetaData = _useMemo.openCameraButtonPressMetaData,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    _stepDetails = _useMemo.stepDetailsProps,
    statusCardProps = _useMemo.statusCardProps,
    variant = _useMemo.variant,
    testID = _useMemo.testID,
    style = _useMemo.style;
  var _useState = useState(isExpanded),
    isExpandedState = _useState[0],
    setIsExpandedState = _useState[1];
  var _useState2 = useState(_state),
    stateType = _useState2[0],
    setStateType = _useState2[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var skycFormWidgetStyle = getSkycFormWidgetStyles(props);
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
  }, [isExpanded]);
  var handleChangeButtonPress = () => {
    if (stateType != 'success') setIsExpandedState(true);
  };
  return isValidObject(_stepDetails) && _jsx(Collapsible, Object.assign({
    withCard: true,
    theme: theme,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    style: [skycFormWidgetStyle.heading, style],
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    showIcon: false,
    isExpanded: isExpandedState,
    disabled: getIsDisabledState(isDisabledState, disableToggle)
  }, getTestId(testID, variant + "_collapsible"), {
    titleComponent: _jsx(LinkListItemWidget, Object.assign({}, _stepDetails, isSuccessState && !isExpandedState && successStateHeading && {
      heading: successStateHeading
    }, {
      roundedCorners: true,
      theme: theme,
      noHoverEffect: true,
      noPressEffect: true,
      onPress: onStepDetailsListItemPressMetaData,
      onUserAction: onUserAction,
      actionTypeProps: !isExpandedState && !isDisabledState && (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.actionTypeProps),
      actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
      actionTypeOnPress: handleChangeButtonPress
    }, isSuccessState && Object.assign({}, successAvatarConfig.stepDetailsProps), {
      subHeading: !isExpandedState && isSuccessState ? successAvatarConfig.stepDetailsProps.subHeading : '',
      disabled: getIsDisabledState(isDisabledState, _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.disabled),
      subHeadingNumberOfLines: (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeadingNumberOfLines) || 1
    }, getTestId(testID, variant + "_linkListItemWidget")))
  }, {
    children: _jsx(View, Object.assign({
      style: [skycFormWidgetStyle.content]
    }, {
      children: _jsx(StatusCardWidget, Object.assign({}, statusCardProps, {
        onUserAction: onUserAction,
        primaryCtaOnPressMetaData: openCameraButtonPressMetaData
      }, getTestId(testID, variant + "_statusCardWidget")))
    }))
  }));
};